// extracted by mini-css-extract-plugin
export default {"root":"PriceRulesBadge_root__PO3iH","badge":"PriceRulesBadge_badge__gUpVa"};